/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Avatar, Divider } from '@mui/material';
import './OffCycleARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import LeaveHistoryArTile from '../../../components/LeaveHistoryTileAr/LeaveHistoryTileAr';
import { getAmount } from '../../../configs/utils';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';
import ImageViewer from '../../../components/ImageViewer/ImageViewer';
import { actionRequiredService } from '../../../../api/services/actionRequiredService';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  fullData?: any;
  historyData?: any;
  handleSubmitAR_Request: any;
  allActions?: any;
  userId: any;
}

const OffCycleARModalPresenter = ({
  isModalOpen,
  closeModal,
  fullData,
  historyData,
  handleSubmitAR_Request,
  trans,
  allActions,
  userId,
}: ModalProps) => {
  const getStatus = ['Pending', 'Approved', 'Rejected'];
  const [openModal, setOpenModal] = useState(false)
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [filename, setFileName] = useState(fullData?.attachment);
  
  useEffect(()=>{
    actionRequiredService
    .getOffCycleAttachment(fullData?.request_id)
    .then((res: any) => {
      setAttachmentUrl(res?.data.attachment);
      console.log(res?.data)
    })
    .catch((err) => {
      console.error(err);
    });
  },[])

  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'claims',
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'emp_claims',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans('Off-Cycle Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar src={fullData?.profile_pic} />
                <Box style={{ paddingLeft: '10px' }}>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.darkBlue,
                      fontSize: '1em',
                      fontWeight: 'bold',
                    }}
                  >
                    {fullData?.first_name + ' ' + fullData?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.grey_colorDesignationAR,
                      fontSize: '0.825em',
                    }}
                  >
                    {fullData?.department_name} /{' '}
                    {fullData?.current_designation}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  backgroundColor: '#F2E6F0',
                  borderRadius: '4px',
                  padding: '2px',
                  width: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  maxWidth: '80px',
                  marginTop: '1em',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                >
                  Addition
                </Typography>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: 'auto',
                  borderRadius: '10px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5em',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Submmission Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Off-cyle Type
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    <DateField
                      value={fullData?.date}
                      format={baseDateFormatting}
                    />
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.lightRedSubtittle,
                    }}
                  >
                    {fullData?.type_name}
                  </Typography>
                </Box>
                <Divider style={{ marginTop: '0.5em' }} />
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5em',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Payment Mode
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.7em',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Amount
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.darkBlue,
                    }}
                  >
                    {fullData?.type}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '0.725em',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                    }}
                  >
                    {getAmount(fullData?.amount)}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} onClick={()=>setOpenModal(true)}/>
                  </Box>
                </Box>
              </Box>

              <Box style={{ marginTop: '1.5em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={'Take Action'}
                />
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}
          <Grid item xs={6}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  History
                </Typography>
              </Box>

              {historyData?.length > 0 &&
                historyData?.map((d: any, index: any) => {
                  return (
                    <div key={index}>
                      <LeaveHistoryArTile
                        actorName=""
                        date1={d?.date}
                        dayOrAmount={getAmount(d?.amount)}
                        remarks={d?.remarks}
                        status={getStatus[d?.status]}
                        typeName={d?.type_name}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
      <CustomModal
        isModalOpen={openModal}
      >
        <ImageViewer
          filename={filename}
          onClose={()=>setOpenModal(false)}
          url={attachmentUrl}
          width={1500}
          height={700}
          img={true}
        />
      </CustomModal>
    </CustomModal>
  );
};

export default OffCycleARModalPresenter;
